import type { NavigateFunction } from 'react-router-dom';

// Storage keys the care navigator uses to resume the last chat on load.
// `chat_session_id` (localStorage) restores the chat-engine conversation and
// `bquest_nav_session_id` (sessionStorage) the results page; `force_new_chat`
// is read once (on the next chat mount) by useNavigatorChat to reset the
// conversation to the greeting instead of restoring the saved session.
const CHAT_SESSION_KEY = 'chat_session_id';
const NAV_SESSION_KEY = 'bquest_nav_session_id';
const FORCE_NEW_CHAT_KEY = 'force_new_chat';

/**
 * Clears the resume artifacts and routes to the Navigator chat so the user
 * starts fresh from the blank Q&A stage instead of falling back into their last
 * generated plan.
 *
 * This mirrors the long-standing NavigatorHub "Start a New Care Plan" behavior
 * exactly (NavigatorHub now delegates here), so the new "Restart guide" action
 * and the hub card stay identical. It deliberately does NOT touch
 * `bquest_nav_care_stage`: that key is shared with the detailed/redesign chat
 * flows and is overwritten on the next completion anyway, so clearing it here
 * would be a needless cross-flow side effect.
 */
export const startNewCarePlan = (navigate: NavigateFunction): void => {
  localStorage.removeItem(CHAT_SESSION_KEY);
  sessionStorage.setItem(FORCE_NEW_CHAT_KEY, 'true');
  sessionStorage.removeItem(NAV_SESSION_KEY);
  navigate('/care-navigator');
};
